import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { LayoutUtilsService } from 'app/core/_base/crud';
import { InvoiceTransmissionStatus } from 'app/core/o2c/inquiries/models/invoice-transmission-status.model';

export interface InvoiceTransmissionHistoryDialogData {
	title: string;
	rows: InvoiceTransmissionStatus[];
}

@Component({
  standalone: false,
	selector: 'kt-invoice-transmission-history-dialog',
	templateUrl: './invoice-transmission-history-dialog.component.html',
	styleUrls: ['./invoice-transmission-history-dialog.component.scss'],
})
export class InvoiceTransmissionHistoryDialogComponent implements OnInit {
	displayedColumns = [
		'transmissionDate',
		'transmissionType',
		'provider',
		'status',
		'userName',
		'invoiceNumber',
		'description',
	];

	dataSource: MatTableDataSource<InvoiceTransmissionStatus>;
	filter = '';

	@ViewChild(MatSort) sort: MatSort;
	@ViewChild(MatPaginator) paginator: MatPaginator;

	constructor(
		public dialogRef: MatDialogRef<InvoiceTransmissionHistoryDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: InvoiceTransmissionHistoryDialogData,
		private layoutUtilsService: LayoutUtilsService
	) {}

	ngOnInit(): void {
		this.dataSource = new MatTableDataSource<InvoiceTransmissionStatus>(
			this.data.rows ?? []
		);
		setTimeout(() => {
			if (this.dataSource && this.sort) {
				this.dataSource.sort = this.sort;
			}
			if (this.dataSource && this.paginator) {
				this.dataSource.paginator = this.paginator;
			}
		});
	}

	applyFilter(filterValue: string): void {
		if (this.dataSource) {
			this.dataSource.filter = filterValue.trim().toLowerCase();
		}
	}

	clearFilters(): void {
		this.filter = '';
		if (this.dataSource) {
			this.dataSource.filter = '';
		}
	}

	onClose(): void {
		this.dialogRef.close();
	}

	showDescription(element: InvoiceTransmissionStatus): void {
		const description = element.description?.trim();
		const modalRef = this.layoutUtilsService.generalAlert();
		modalRef.componentInstance.title = 'Description';
		modalRef.componentInstance.data = description || 'No description available.';
	}

	getStatusClass(status: string | undefined): string {
		const normalized = String(status ?? '').trim().toUpperCase();
		if (normalized === 'SENT') {
			return 'status-sent';
		}
		if (normalized === 'FAILED') {
			return 'status-failed';
		}
		return 'status-default';
	}
}
